import React, { useState } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import PeriodSlider from 'components/Meteorology/Weather/SeasonalForecast/PeriodSlider';
import SeasonalForecastToolbar from 'components/Meteorology/Weather/SeasonalForecast/Toolbar';
import ImageDisplay from 'components/Meteorology/Weather/SeasonalForecast/ImageDisplay';
import InstructionsModal from 'components/Meteorology/Weather/SeasonalForecast/InstructionsModal';
import SeasonalForecastControlPanel from 'components/Meteorology/Weather/ControlPanel/SeasonalForecast';

import './index.scss';

export default function SeasonalForecastMobile() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <div className="weather-seasonal-mobile">
      <InstructionsModal show={showInstructions} onHide={() => setShowInstructions(false)} />

      <QueryCard>
        <QueryCardHeader label="Previsão Sazonal" title="Configure a previsão sazonal" />
        <QueryCardTrigger onClick={() => setPanelOpen(true)} />
      </QueryCard>

      <div className="weather-seasonal-mobile-toolbar">
        <div className="weather-seasonal-mobile-period">
          <PeriodSlider />
        </div>
        <SeasonalForecastToolbar onInstructionsClick={() => setShowInstructions(true)} />
      </div>

      <ImageDisplay />

      <BottomSheet open={panelOpen} dismiss={() => setPanelOpen(false)} title="Painel de controle">
        <SeasonalForecastControlPanel />
      </BottomSheet>
    </div>
  );
}
